import { TruckSize } from '../../../../../../common';

export interface UliDefaultHubTruckMappingModel {
  byDefault: boolean;
  handlingUnitEffort: number;
  loadingMeterEffort: number;
  mappingNames: string[];
  maxHandlingUnits: number;
  maxLoadingMeters: number;
  sizeType: TruckSize;
}
